module.exports = __webpack_public_path__ + "img/app_icon.0b924f4c.png";